export enum LogLevel { ALL, TRACE, DEBUG, INFO, WARN, ERROR, FATAL, OFF }
